import React from "react"
import { graphql, Link } from "gatsby"
import { Helmet } from "react-helmet"
import SEO from "../../components/seo"
import Layout from "../../components/layout"
import Hero from "../../components/hero"
import PostSidebar from "../../components/postSidebar"
import PostList from "../../components/postList"
import Categories from "../../components/categories"
import Pagination from "../../components/pagination"

export const query = graphql`
  query($skip: Int, $limit: Int) {
    sanitySiteConfig {
      url
    }
    allSanityBlog(
      sort: { fields: publishDate, order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          title
          slug {
            current
          }
          category {
            title
            slug {
              current
            }
            colorPalette {
              color
            }
          }
          excerpt
        }
      }
    }
    sanityBlogListing {
      blogListingSettings {
        title
        breadcrumbTitle
      }
    }
  }
`

const BlogList = props => {
  const { data } = props
  const { currentPage, blogPages } = props.pageContext
  const { blogListingSettings } = data.sanityBlogListing
  const title = `The LEO Learning Blog`
  const customTitle = `The eLearning Blog by LEO Learning`
  const canonical = `${data.sanitySiteConfig.url}blog/`
  const heroTitle = blogListingSettings.title
  const breadcrumbTitle = blogListingSettings.breadcrumbTitle

  return (
    <Layout>
      <Helmet>
        <link rel="canonical" href={canonical} />
      </Helmet>
      <SEO title={title} customTitle={customTitle} />
      <Hero title={heroTitle} gridParams="xlarge-6 xlarge-offset-3">
        <p>
          <Link to="/">Home</Link> <Link to="/blog/">{breadcrumbTitle}</Link>
        </p>
      </Hero>
      <div className="grid">
        <div className="gridItem large-3">
          <PostSidebar>
            <Categories postType="blog" />
          </PostSidebar>
        </div>
        <div className="gridItem large-8">
          <PostList posts={data.allSanityBlog.edges} postType="blog" />
          {blogPages > 1 && (
            <Pagination
              type="blog"
              currentPage={currentPage}
              totalPages={blogPages}
            />
          )}
        </div>
      </div>
    </Layout>
  )
}

export default BlogList
